import { Form, Modal, Field, Input, Toast, ActionButton } from "components/commons";
import { useForm, useModal } from "hooks";
import React, { useCallback, useEffect, useMemo } from "react";
import lang from "translations";
import initialFormState from "./notification-email-form-state";
// import DeletePaymentMethodModal from "../delete-payment-method/delete-payment-method.modal";

const NotificationEmailForm = ({
  title,
  active,
  close,
  primaryText,
  initialState = undefined,
  save,
  submitting,
  deleteButton,
  params,
}) => {
  const unsaveChangesModal = useModal();
  const deletePaymentMethodModal = useModal();

  const formState = useMemo(() => {
    return initialFormState(initialState);
  }, [initialState]);

  const { dirty, fields, modifyField, clearForm, submitForm, getFormValues, applyFieldErrors } =
    useForm({
      initialState: formState,
    });

  const exitForm = () => {
    clearForm();
    unsaveChangesModal.close();
  };

  const onClose = () => {
    if (dirty) {
      unsaveChangesModal.show({
        ok: () => {
          exitForm();
          setTimeout(() => {
            close();
          });
        },
      });
      return;
    }
    close();
    exitForm();
  };

  useEffect(() => {
    if (active) {
      clearForm();
    }
    // eslint-disable-next-line
  }, [active]);

  const onSave = useCallback(() => {
    save(
      { ...getFormValues(), ...params },
      (res, { message }) => {
        Toast({
          content: message,
          success: true,
          icon: "check",
        }).open();
        close();
        clearForm();
      },
      ({ code, handleError }) => {
        const err = {
          3084: () => {
            applyFieldErrors({
              email: lang.thisEmailIsAlreadyAdded,
            });
          },
        };
        if (err[code]) {
          err[code]();
        } else {
          handleError();
        }
      }
    );
  }, [save, clearForm, close, getFormValues, applyFieldErrors, params]);

  return (
    <div>
      <Modal
        active={active}
        hidden={unsaveChangesModal.active || deletePaymentMethodModal.active}
        onClose={() => onClose()}
        primaryText={primaryText}
        loading={submitting}
        noCloseButton
        title={title}
        actionContent={
          <ActionButton
            loading={submitting}
            className="mb-md ml-md mr-md pb-md"
            mb="md"
            primary={{
              text: primaryText,
              onClick: () => submitForm(onSave),
              disabled: !dirty,
            }}
            secondary={{
              onClick: () => onClose(),
              text: lang.cancel,
            }}
            danger={deleteButton}
          />
        }
      >
        <Form unsaveChangesModal={unsaveChangesModal} isPrompt={dirty}>
          <Field {...fields.firstName}>
            <Input required {...fields.firstName} onChange={modifyField} />
          </Field>
          <Field {...fields.lastName} className="mt-md">
            <Input required {...fields.lastName} onChange={modifyField} />
          </Field>
          <Field {...fields.email} className="mt-md">
            <Input required {...fields.email} onChange={modifyField} />
          </Field>
        </Form>
      </Modal>
    </div>
  );
};

export default NotificationEmailForm;
